import { useMemo } from "react";
import useAppContext from "components/AppContext";
import { useXS } from "@ww-digital/xs-sdk-react";

export const useCashPayWegovy = (): {
  cashPayWegovyEligible: boolean;
  cashPayWegovyIsReady: boolean;
} => {
  const { profile } = useAppContext();

  const { value: cashPayWegovyEnabled = false, isReady: cashPayWegovyIsReady = false } =
    useXS("WPF1420_CASH_PAY_WEGOVY");

  const cashPayWegovyEligible = useMemo(() => {
    return cashPayWegovyEnabled && cashPayWegovyIsReady && !profile?.isB2B;
  }, [cashPayWegovyEnabled, cashPayWegovyIsReady, profile?.isB2B]);

  return {
    cashPayWegovyEligible,
    cashPayWegovyIsReady
  };
};
